import axios from 'axios';

import API from './api';

class Babel extends API {
  constructor() {
    super();

    this.$axios = axios.create({
      baseURL: '/babel/api',
    });
  }
}

const babel = new Babel();

export default babel;
